<template>
    <div
        v-tooltip="tooltip"
        class="sg-custom-toggle sg-vrm-toggle sg-slide-colors"
        :class="{ 'sg-disabled': disabled, 'sg-with-tooltip': !!tooltip }"
    >
        <label :for="labelId">
            <input :id="labelId" v-model="state" type="checkbox" :disabled="disabled" />
            <div class="sg-alternative-display">
                <div class="sg-on" />
                <div class="sg-off" />
                <div class="sg-knob">
                    <div class="sg-dot" />
                </div>
            </div>
            <div class="sg-caption-container">
                <div class="sg-caption">
                    <slot>
                        <span class="sg-on">{{ on }}</span>
                        <span class="sg-off">{{ off }}</span>
                    </slot>
                </div>
            </div>
        </label>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import ToggleMixin from '@/vue/components/shared/toggles/ToggleMixin';

@Component
@AngularDirective('vrm-toggle')
export default class VrmToggle extends ToggleMixin {
    @Prop({ type: Boolean, default: false })
    noColors;
    @Prop()
    disabled;
    @Prop()
    on;
    @Prop()
    off;

    @Prop({ type: String })
    tooltip;

    get labelId() {
        return `vrm_toggle_${this._uid}`;
    }
}
</script>
